import { act, useEffect, useState } from "react";
import "./App.css";
import profile from "./assets/profile.png";
import Loader from "./Loader";
import { fetchData } from "./api"; // Import the function
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
} from "firebase/firestore";
import { ActiveUsers } from "./ActiveUsers";
import { LeaderBoard } from "./LeaderBoard";
import { addDoc } from "firebase/firestore";
import { serverTimestamp } from "firebase/firestore";
import RewardVideo from "./RewardAd";
export default function HomeTG() {

  const [adDisplayed,setAdDisplayed] = useState(false);
  const db = getFirestore();
  const [claiming, setClaiming] = useState(false);
  const [loading, setLoading] = useState(true);
  const [cloud, setCloud] = useState(global.getProfileData());
  const [claimData, setClaimData] = useState(global.getClaimData());
  const [emrsPriceOne, setEmrsPriceOne] = useState("0.00");
  const [emrsPriceTwo, setEmrsPriceTwo] = useState("0.00");
  const [conversionPrice, setConversionPrice] = useState(0.00041);
  const [widthLine, setWidthLine] = useState(20);
  const [username, setUsername] = useState("User");
  const [activeToken, setActiveToken] = useState("");
  const [claimable, setClaimable] = useState(0);
  const [totalCalories, setTotalCalories] = useState(0);
  const [claimTime, setClaimTime] = useState(0);
  const isTimestampToday = (timestamp) => {
    const date = new Date(timestamp * 1000); // Convert to milliseconds
    const today = new Date();
    return (
      date.getUTCFullYear() === today.getUTCFullYear() &&
      date.getUTCMonth() === today.getUTCMonth() &&
      date.getUTCDate() === today.getUTCDate()
    );
  };
  async function logAndUpdateEMRS(tgUserid, emrsToAdd, eventType) {
    setClaiming(true);
    try {
      const tgUseridNum = Number(tgUserid);
      await addDoc(collection(db, "telegram_emrs_log"), {
        tgUserid: tgUseridNum,
        EMRS: emrsToAdd,
        type: eventType,
        timestamp: new Date(),
      });
      console.log(
        `Log added for tgUserid ${tgUseridNum} with ${emrsToAdd} EMRS.`
      );
      const logsQuery = query(
        collection(db, "telegram_emrs_log"),
        where("tgUserid", "==", tgUseridNum)
      );
      const logsSnapshot = await getDocs(logsQuery);
      let totalEMRS = 0;
      logsSnapshot.forEach((doc) => {
        //totalEMRS += doc.data().EMRS;
        if (
          doc.data().EMRS &&
          doc.data().EMRS != null &&
          !isNaN(doc.data().EMRS)
        ) {
          totalEMRS += doc.data().EMRS;
        }
      });
      console.log(`Total EMRS for tgUserid ${tgUseridNum}: ${totalEMRS}`);
      const usersQuery = query(
        collection(db, "telegram_users"),
        where("tgUserid", "==", tgUseridNum)
      );
      const usersSnapshot = await getDocs(usersQuery);
      const updatePromises = usersSnapshot.docs.map((userDoc) => {
        return updateDoc(doc(db, "telegram_users", userDoc.id), {
          totalEMRS: totalEMRS,
        });
      });
      await Promise.all(updatePromises);
      console.log(
        `Updated totalEMRS for all users with tgUserid ${tgUseridNum}`
      );
      getTelegramUser(tgUserid);
      setClaiming(false);
    } catch (error) {
      setClaiming(false);
      console.error("Error in logAndUpdateEMRS:", error);
    }
  }
  const claimNowCalories = async (toClaim) => {
    hideAdNow();
    toClaim = parseInt(toClaim);
    setClaiming(true);
    try {
      const usersRef = collection(db, "telegram_users");
      const q = query(usersRef, where("tgUserid", "==", tgUserid));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const userDoc = querySnapshot.docs[0]; // Assuming tgUserid is unique
        const userRef = doc(db, "telegram_users", userDoc.id);
        const currentEmrs = userDoc.data().totalEMRS || 0; // Get existing value or default to 0
        //        const newTotalEmrs = currentEmrs + (toClaim * 1.5);
        const toAddEMRS = parseInt(toClaim) * 1.5;
        var alreadyClaimed = userDoc.data().claimed_today
          ? userDoc.data().claimed_today
          : 0;
        if (!userDoc.data().last_claimed) {
          alreadyClaimed = 0;
        } else if (!isTimestampToday(userDoc.data().last_claimed)) {
          alreadyClaimed = 0;
        }
        const totalClamiedToday = parseInt(alreadyClaimed) + toClaim;
        await updateDoc(userRef, {
          last_claimed: claimTime,
          claimed_today: totalClamiedToday,
        });
        logAndUpdateEMRS(tgUserid, toAddEMRS, "BMRCLAIM");
        //        getTelegramUser(tgUserid);
      } else {
        setClaiming(false);
        console.log("No user found with tgUserid =", tgUserid);
      }
    } catch (error) {
      setClaiming(false);
      console.error("Error updating totalEmrs:", error);
    }
  };
  async function getTelegramUser(tgUserid) {
    try {
      const q = query(
        collection(db, "telegram_users"),
        where("tgUserid", "==", tgUserid)
      );
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const userData = querySnapshot.docs[0].data();
        console.log("User Data:", userData);
        setCloud({ ...cloud, userData: userData });
        if (!userData.totalEMRS) {
          userData.totalEMRS = 0;
        }
        var erOne = parseInt(userData.totalEMRS);
        //        erOne = parseFloat(erOne).toFixed(4);
        setEmrsPriceOne(erOne);
        setTotalCalories(userData.totalCalories);
        var tc = userData.totalCalories;
        var erTwo = parseInt(tc) * 1.5;
        setEmrsPriceTwo(erTwo);
        const currentTimestamp = Math.floor(Date.now() / 1000); // Current timestamp in seconds
        setClaimTime(currentTimestamp);
        const now = new Date();
        const startOfToday = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          0,
          0,
          0
        );
        const startOfTodayTimestamp = Math.floor(startOfToday.getTime() / 1000);
        if (!userData.claimed_today) {
          userData.claimed_today = 0;
        }
        if (!userData.last_claimed) {
          userData.last_claimed = startOfTodayTimestamp;
        } else {
          if (userData.last_claimed < startOfTodayTimestamp) {
            userData.last_claimed = startOfTodayTimestamp;
            userData.claimed_today = 0;
          }
        }
        var claimUnit = parseFloat(userData.totalCalories / (24 * 60));
        console.log("claimUnit", claimUnit);
        var SixUnit = claimUnit * 60 * 6;
        console.log("SixUnit", SixUnit);
        var claimTill =
          (Math.abs(currentTimestamp - userData.last_claimed) / 60) * claimUnit;
        console.log("claimTill", claimTill);
        if (claimTill > SixUnit) {
          claimTill = SixUnit;
        }
        console.log("claimTill", claimTill);
        var cc = Math.floor(
          (userData.claimed_today / userData.totalCalories) * 100
        );
        cc = parseInt(cc);
        setWidthLine(cc);
        setClaimable(claimTill.toFixed(2));
        setLoading(false);
        setClaiming(false);
        return userData;
      } else {
        console.log("No user found with tgUserid:", tgUserid);
        return null;
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      return null;
    }
  }
  // Example usage:
  const [tgUserid, setTgUserId] = useState(0);
  useEffect(() => {
    setTgUserId(parseInt(localStorage.getItem("TGUSERID")));
    getTelegramUser(parseInt(localStorage.getItem("TGUSERID")));
  }, []);
  useEffect(() => {
    const getData = async () => {
      const response = await fetchData("https://api.emorya.com/emrs-price");
      console.log(response);
      if (response) {
        var price = response[0].usdPrice;
        console.log(price);
        setConversionPrice(price);
      }
    };
    getData();
  }, []);
  const showAds = () => {
    
    setAdDisplay(true);
  };
  const hideAdNow = () => {
    setAdDisplay(false);
  };
  const [adDisplay, setAdDisplay] = useState(false);

 

  return (
    <>
      {adDisplay ? (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.8)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 200000,
            }}
          >
            <RewardVideo callBack={claimNowCalories} callBackArgs={claimable}></RewardVideo>
          </div>
        </>
      ) : null}
      <div className="section">
        <div
          style={{
            padding: 10,
            paddingTop: 20,
            textAlign: "left",
            width: "100%",
          }}
        >
          <Loader loading={loading}></Loader>
          <div
            className="row"
            style={{
              width: "100%",
              margin: 0,
            }}
          >
            <div className="col-2">
              <div
                className="profileImage"
                style={{
                  backgroundImage:
                    cloud.userData.imageUrl &&
                    cloud.userData.imageUrl != "" &&
                    cloud.userData.imageUrl != null
                      ? `url(${cloud.userData.imageUrl})`
                      : `url(${profile})`,
                }}
              ></div>
            </div>
            <div className="col-10">
              <div
                onClick={() => {
                  global.changeSection("MVXSTATS");
                }}
                style={{
                  float: "right",
                  marginTop: -4,
                }}
              >
                <span
                  className="badge bg-light token"
                  style={{
                    backgroundColor: "#351059 !important",
                  }}
                >
                  EMR TOKEN &nbsp;
                  <i
                    className="fa-solid fa-arrow-up-right-from-square"
                    style={{
                      fontSize: 10,
                    }}
                  ></i>
                </span>
              </div>
              <div
                className="dashedBottom"
                style={{
                  fontWeight: "bold",
                }}
              >
                {cloud.userData.firstName} {cloud.userData.lastName}
              </div>
              <div
                style={{
                  fontSize: 11,
                  paddingTop: 5,
                }}
              >
                <div
                  style={{
                    float: "left",
                  }}
                >
                  {cloud.userData.totalCalories &&
                  cloud.userData.totalCalories != ""
                    ? parseFloat(cloud.userData.totalCalories).toFixed(2) +
                      " kCal"
                    : ""}
                </div>
              </div>
            </div>
            <div
              className="col-sm-12"
              style={{
                padding: "40px 10px",
              }}
            >
              <br />
            
              <div className="glowBox">
                <div
                  style={{
                    padding: 20,
                  }}
                >
                  <div
                    style={{
                      float: "right",
                    }}
                  >
                    <img
                      alt=""
                      src={require("./assets/monoNew.png")}
                      style={{
                        width: 40,
                      }}
                    ></img>
                  </div>
                  <strong
                    style={{
                      fontSize: 20,
                    }}
                  >
                    {cloud.userData.totalEMRS ? cloud.userData.totalEMRS : 0}{" "}
                    EMRS
                  </strong>
                  <div
                    style={{
                      fontSize: 12,
                    }}
                  >
                    = $ {(emrsPriceOne * conversionPrice).toFixed(4)}
                  </div>
                  <br />
                  <div
                    style={{
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                  >
                    <div
                      style={{
                        float: "right",
                        fontSize: 11,
                        color: "#fff",
                        fontWeight: "normal",
                      }}
                    >
                      <span
                        style={{
                          fontSize: 15,
                          color: "#fff",
                          fontWeight: "bold",
                        }}
                      >
                        {cloud.userData.claimed_today}
                      </span>
                      /{parseFloat(cloud.userData.totalCalories).toFixed(2)} ( =
                      $ {(emrsPriceTwo * conversionPrice).toFixed(4)})
                    </div>
                    Daily Calories
                    <div
                      style={{
                        backgroundColor: "#482253",
                        borderColor: "#482253",
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderRadius: 5,
                        position: "relative",
                        width: "100%",
                        height: 32,
                        overflow: "hidden",
                        marginTop: 10,
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#DB5E9C",
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: widthLine + "%",
                          height: 30,
                        }}
                      ></div>
                    </div>
                    <br />
                    <div className="dashedBottom"></div>
                    <br />
                    <strong
                      style={{
                        color: "#DB5E9C",
                        fontSize: 40,
                      }}
                    >
                      {claimable} kCal
                    </strong>
                    <div
                      style={{
                        fontSize: 12,
                        marginTop: -5,
                      }}
                    >
                      Claimable Calories
                    </div>
                    <button
                      onClick={() => {
                        if (!claiming) {
                          if(adDisplayed){
                            claimNowCalories(claimable);
                          }else{
                            showAds();
                          }
                        }
                      }}
                      className="btn btn-sm btn-success gradColor"
                      style={{
                        marginTop: 10,
                      }}
                    >
                      {claiming ? (
                        "Claiming.."
                      ) : (
                        <>
                          Claim Now <i className="fas fa-arrow-right"></i>
                        </>
                      )}
                    </button>
                    <br />
                  </div>
                </div>
              </div>
              <br />
              <br />
              <LeaderBoard activeToken={null}></LeaderBoard>
              <div className="glowBox">
                <ActiveUsers></ActiveUsers>
              </div>
              <br />
              <br />
              <div
                style={{
                  height: 200,
                }}
              ></div>
              <div
                style={{
                  padding: 20,
                  display: "none",
                }}
              >
                <strong
                  style={{
                    fontSize: 30,
                  }}
                >
                  Burn Calories <br />
                  And Make Money!
                </strong>
                <br />
                <div
                  style={{
                    fontSize: 14,
                  }}
                >
                  Burn calories and get rewards, simple and easy, right from
                  your phone.
                </div>
                <br />
                <button
                  className="btn btn-sm btn-light"
                  onClick={() => {
                    global.changeSection("CALCULATOR");
                  }}
                >
                  <i
                    className="fa-solid fa-border-none"
                    style={{
                      fontSize: 12,
                      marginTop: -3,
                    }}
                  ></i>
                  &nbsp; Calculate How <i className="fas fa-arrow-right"></i>
                </button>
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
